
const Twitter = () => {
    return (
        <a className="twitter-timeline"
            href="https://twitter.com/vueloupm"
            data-width="500"
            data-height="500">
        </a>

    )
}

export default Twitter